import React from 'react';
import { Link } from 'react-router-dom';
// import StarRatingComponent from 'react-star-rating-component';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import Pagination from "react-js-pagination";
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import * as constant from '../../constants/constant';
import moment from 'moment';
import Moment from 'react-moment';
import DatePicker from 'react-datepicker';
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";

// {constant.PRODUCTION_IMAGE_URL + 'patientImage/' + image}
const size = 10;
let btnSize = { fontSize: '13' };
class SpecialistDocuments extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			specialistPatients: [],
			sortColumnName: '',
			sortOrder: -1,
			activePage: 1,
			count: size,
			totalCount: size,
			//search patient
			searchedPatientName: '',
			isSearch: false,
			// searchDate: ''
			logoutButton: false
		}
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.searchByPatientName = this.searchByPatientName.bind(this);
		this.submitSearch = this.submitSearch.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.resetSearch = this.resetSearch.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);


	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}

	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	resetSearch() {
		this.setState({ searchedPatientName: '', searchDate: null });
		let userObj = {
			specialistId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage
		};
		this.props.actions.getSpecialistPatients(userObj);
	}
	submitSearch() {
		let userObj = {
			specialistId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage,
			name: this.state.searchedPatientName,
			dateOfBirth: this.state.searchDate,
			clinicCountryZone: localStorage.getItem('clinicCountryZone')
		};
		this.props.actions.getSpecialistPatients(userObj);
	}

	searchByPatientName(event) {
		var state = this.state;
		if (event.target.name == "name") {
			state.searchedPatientName = event.target.value;
			this.setState(state);
		}
	}
	handleChange(date) {
		this.setState({ searchDate: date });
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		var obj = {
			doctorId: localStorage.getItem('userId'),
			count: this.state.count,
			page: pageNumber
		}
		this.props.actions.getMyFeedback(obj);
	}
	componentWillMount() {

		let userObj = {
			specialistId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage
		};
		this.props.actions.getSpecialistPatients(userObj);
	}
	componentWillReceiveProps(nextProps) {
		
		if (nextProps.specialistPatients && nextProps.specialistPatients.myPatient != null || nextProps.message == 'No Data Found') {
			this.setState({
				specialistPatients: nextProps.specialistPatients.myPatient ? nextProps.specialistPatients.myPatient : [],
				totalCount: nextProps.specialistPatients.totalCount ? nextProps.specialistPatients.totalCount : 0,
				isLoader: false
			})
		}

	}

	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;

		let userObj = {
			specialistId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage,
			sorting: sorting
		};
		this.props.actions.getSpecialistPatients(userObj);
	}

	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}
	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		var specialistPatients = this.state.specialistPatients;
		// var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
			// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var rowsList = [];
		this.state.specialistPatients && this.state.specialistPatients.forEach(function (item, index) {
			rowsList.push(<tr key={index}>
				<td className="tadalist">
					{item.profileImage == constant.DEFAULT_USER_IMAGE ? <img className="profile-user-img img-responsive img-circle" src={item.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
					} alt="User profile picture" onError={e => {
						e.target.src = defaultImagePath;
					}} /> : <img className="profile-user-img img-responsive img-circle" src={defaultImagePath/* constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + item.patients[0]._id + '/' + item.profileImage */} alt="User profile picture" onError={e => {
						e.target.src = defaultImagePath;
					}} />}

				</td>
				{!user.assistId ? <td className="name text-capitalize"><Link to={"/specialist/appointment-history/" + item.patients[0]._id}>{item.patients[0].userName}</Link> </td>
					: <td className=" text-capitalize">{item.patients[0].userName} </td>
				}
				<td>{item.patients[0].patientSince ? <Moment format="DD-MM-YYYY">{item.patients[0].patientSince}</Moment>: "No booking Yet"}</td>
				<td>{moment().diff(item.dateOfBirth, 'years') != 0 ? moment().diff(item.dateOfBirth, 'years') + ' Y' : moment().diff(item.dateOfBirth, 'month') + ' M'}</td>
				<td> {item.gender}</td>
				<td><Moment format="DD-MM-YYYY">{item.dateOfBirth}</Moment>  </td>
				<td className="activegren">Active</td>
			</tr>)
		}.bind(this));
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		
		return (
			<div>
				<header className="main-header">

				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>
									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">

					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li ><Link to="#tab_1" data-toggle="tab" className="active show">My Patients</Link></li>
										</ul>
										<div className="row">
											<div className="col-md-4 col-lg-8 col-xl-4">
												<div className="boxMrgB">
													<div className="input-group inputBg"><span className="input-group-addon"><i className="fa ">		<img src={require('../../images/img/user_input_icon.svg')} alt="" /></i></span>
														<input type="text" name="name" value={this.state.searchedPatientName} onChange={this.searchByPatientName} className="form-control" placeholder="Patient Name" />
													</div>
												</div>
											</div>
											<div className="col-lg-4">
											<div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">

												<div className="input-group date inputBg" style={{ color: '#4d4d4d !important', 'maxHeight': 47 }}>
													<div className="input-group-addon"><i className="fa ">
														<img src={require('../../images/img/date_input_icon.svg')} /></i></div>
													<DatePicker
														name="dateOfBirth"
														dateFormat="dd-MM-yyyy"
														onChange={this.handleChange}
														placeholderText="Date of birth"
														// maxDate={moment()}
														// minDate={moment().subtract(50, 'year')}
														showMonthDropdown
														showYearDropdown={true}
														shouldCloseOnSelect={true}
														selected={this.state.searchDate}
													/>
												</div>
												</div>
											</div>
											<div className="col-md-12 col-lg-12 col-xl-2">
												<div className="boxMrgB">
													<button type="button" className="btn btn-block btn-warning btn-lg" onClick={this.submitSearch}>Search</button>
												</div>
											</div>
											<div className="col-md-12 col-lg-5 col-xl-2">
												<div className="boxMrgB">
													<button type="button" className="btn btn-block btn-warning btn-lg" onClick={this.resetSearch}>Reset</button>
												</div>
											</div>
										</div>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother ">
													<div className="row">
														<div className="box-body table-responsive no-padding aTable">
															<div className="table-responsive">
																<table className="table">
																	<tbody>
																		<tr>
																			<th>&nbsp;  </th>
																			<th onClick={this.sortChanged.bind(this, 'encryptedName', this.state.sortOrder)}>Patient Name	<i className={this._sortClass('username')}></i></th>
																			<th onClick={this.sortChanged.bind(this, 'dateOfBirth', this.state.sortOrder)}>Patient Since <i className={this._sortClass('age')}></i></th>
																			<th onClick={this.sortChanged.bind(this, 'dateOfBirth', this.state.sortOrder)}>Age <i className={this._sortClass('age')}></i></th>
																			<th onClick={this.sortChanged.bind(this, 'gender', this.state.sortOrder)}>Sex <i className={this._sortClass('sex')}></i></th>
																			<th onClick={this.sortChanged.bind(this, 'dateOfBirth', this.state.sortOrder)}>Date of birth<i className={this._sortClass('dateOfBirth')}></i></th>
																			<th>Status</th>
																		</tr>
																		{rowsList && rowsList.length > 0 ? rowsList : <tr><td colSpan={6}><p className="text-center noUpcomingTable">No Patients Found.</p></td></tr>}
																	</tbody>
																</table>
															</div></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								{(rowsList && rowsList.length > 0) ?
									<div className="row" style={{ 'marginTop': 30 }}>
										<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
										<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
											<Pagination
												prevPageText='Prev'
												nextPageText='Next'
												hideFirstLastPages
												activePage={this.state.activePage}
												itemsCountPerPage={size}
												pageRangeDisplayed={size}
												totalItemsCount={this.state.totalCount}
												onChange={this.handlePageChange.bind(this)}
											/>

										</div>

									</div> : ''}
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div >
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	// debugger;
	return {
		specialistPatients: state.specialist.specialistPatients.data,
		message: state.specialist.specialistPatients.message
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistDocuments);
